import { AppDispatch } from "../../store";
import { PluginContextType } from '../plugin/types';
import { settingsActions } from "./slice";
import { OutputWindow, WindowSize } from "./types";

type LegacySettings = {
  ccli: string,
  display: {
    width: number,
    height: number
  },
  outputs: OutputWindow[]
}

type LegacyState = null | {
  settings: LegacySettings
}

export const migrateFromPreviousVersion = (dispatch: AppDispatch) => {
  const previousStr = localStorage.getItem('redux');
  if (previousStr) {
    const previous = JSON.parse(previousStr) as LegacyState;

    if (previous) {
      const settings = previous.settings;

      if (settings.ccli) {
        dispatch(settingsActions.setCCLILicenseNumber(settings.ccli));
      }
      if (settings.display) {
        dispatch(settingsActions.setCanvasSize(settings.display));
      }
      for (const window of settings.outputs) {
        if (!window.width) {
          window.width = settings.display.width;
        }
        if (!window.height) {
          window.height = settings.display.height;
        }
        dispatch(settingsActions.addOutputWindow(window));
      }
    }

  }
};

export const calculateMaxExtent = (screens: ScreenDetailed[]): WindowSize => ({
  width: Math.max(...screens.map(s => s.left + s.width)),
  height: Math.max(...screens.map(s => s.top + s.height))
});

export const applyOutputWindowSettings = (dispatch: AppDispatch, display: WindowSize, plugin: PluginContextType, windows: OutputWindow[]) => {
  dispatch(settingsActions.setOutputWindows(windows));

  for (const [idx, window] of windows.entries()) {
    plugin.openOutputWindow(window, display, idx);
  }
};
